/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateUnit200,
  CreateUnit200,
  CreateUnitRequest,
  DeactivateUnit200,
  DeleteUnit200,
  PagedResponseUnit,
  SearchUnitsParams,
  Unit,
  UpdateUnit200,
  UpdateUnitRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List all units of measure (active and inactive)
 */
export const listUnits = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<Unit[]>(
      {url: `/api/v1/units`, method: 'GET', signal
    },
      );
    }
  



export const getListUnitsQueryKey = () => {
    return [
    `/api/v1/units`
    ] as const;
    }

    
export const getListUnitsQueryOptions = <TData = Awaited<ReturnType<typeof listUnits>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUnitsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnits>>> = ({ signal }) => listUnits(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUnitsQueryResult = NonNullable<Awaited<ReturnType<typeof listUnits>>>
export type ListUnitsQueryError = unknown


export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUnits>>,
          TError,
          Awaited<ReturnType<typeof listUnits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUnits>>,
          TError,
          Awaited<ReturnType<typeof listUnits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all units of measure (active and inactive)
 */

export function useListUnits<TData = Awaited<ReturnType<typeof listUnits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new unit of measure
 */
export const createUnit = (
    createUnitRequest: CreateUnitRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateUnit200>(
      {url: `/api/v1/units`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUnitRequest, signal
    },
      );
    }
  


export const getCreateUnitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUnit>>, TError,{data: CreateUnitRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUnit>>, TError,{data: CreateUnitRequest}, TContext> => {

const mutationKey = ['createUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUnit>>, {data: CreateUnitRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUnit(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof createUnit>>>
    export type CreateUnitMutationBody = CreateUnitRequest
    export type CreateUnitMutationError = unknown

    /**
 * @summary Create a new unit of measure
 */
export const useCreateUnit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUnit>>, TError,{data: CreateUnitRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUnit>>,
        TError,
        {data: CreateUnitRequest},
        TContext
      > => {

      const mutationOptions = getCreateUnitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Permanently delete a unit — only allowed if it is not referenced by any price list item, offer line, or contract line
 */
export const deleteUnit = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteUnit200>(
      {url: `/api/v1/units/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUnitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUnit>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUnit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUnit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUnitMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUnit>>>
    
    export type DeleteUnitMutationError = unknown

    /**
 * @summary Permanently delete a unit — only allowed if it is not referenced by any price list item, offer line, or contract line
 */
export const useDeleteUnit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUnit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUnit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUnitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a unit's localized names (code is immutable)
 */
export const updateUnit = (
    id: string,
    updateUnitRequest: UpdateUnitRequest,
 ) => {
      
      
      return apiClient<UpdateUnit200>(
      {url: `/api/v1/units/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUnitRequest
    },
      );
    }
  


export const getUpdateUnitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUnit>>, TError,{id: string;data: UpdateUnitRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUnit>>, TError,{id: string;data: UpdateUnitRequest}, TContext> => {

const mutationKey = ['updateUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUnit>>, {id: string;data: UpdateUnitRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUnit(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof updateUnit>>>
    export type UpdateUnitMutationBody = UpdateUnitRequest
    export type UpdateUnitMutationError = unknown

    /**
 * @summary Update a unit's localized names (code is immutable)
 */
export const useUpdateUnit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUnit>>, TError,{id: string;data: UpdateUnitRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUnit>>,
        TError,
        {id: string;data: UpdateUnitRequest},
        TContext
      > => {

      const mutationOptions = getUpdateUnitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivate a unit — hidden from new-entry dropdowns, existing references keep resolving
 */
export const deactivateUnit = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivateUnit200>(
      {url: `/api/v1/units/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateUnitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUnit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateUnit>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateUnit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateUnit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateUnit>>>
    
    export type DeactivateUnitMutationError = unknown

    /**
 * @summary Deactivate a unit — hidden from new-entry dropdowns, existing references keep resolving
 */
export const useDeactivateUnit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUnit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateUnit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateUnitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Activate a unit
 */
export const activateUnit = (
    id: string,
 ) => {
      
      
      return apiClient<ActivateUnit200>(
      {url: `/api/v1/units/${id}/activate`, method: 'PATCH'
    },
      );
    }
  


export const getActivateUnitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateUnit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateUnit>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateUnit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateUnit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof activateUnit>>>
    
    export type ActivateUnitMutationError = unknown

    /**
 * @summary Activate a unit
 */
export const useActivateUnit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateUnit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateUnit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getActivateUnitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Paginated, filterable unit list for the admin Units list page
 */
export const searchUnits = (
    params?: SearchUnitsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseUnit>(
      {url: `/api/v1/units/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchUnitsQueryKey = (params?: SearchUnitsParams,) => {
    return [
    `/api/v1/units/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchUnitsQueryOptions = <TData = Awaited<ReturnType<typeof searchUnits>>, TError = unknown>(params?: SearchUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUnits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUnitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUnits>>> = ({ signal }) => searchUnits(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchUnitsQueryResult = NonNullable<Awaited<ReturnType<typeof searchUnits>>>
export type SearchUnitsQueryError = unknown


export function useSearchUnits<TData = Awaited<ReturnType<typeof searchUnits>>, TError = unknown>(
 params: undefined |  SearchUnitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUnits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUnits>>,
          TError,
          Awaited<ReturnType<typeof searchUnits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUnits<TData = Awaited<ReturnType<typeof searchUnits>>, TError = unknown>(
 params?: SearchUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUnits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUnits>>,
          TError,
          Awaited<ReturnType<typeof searchUnits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUnits<TData = Awaited<ReturnType<typeof searchUnits>>, TError = unknown>(
 params?: SearchUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUnits>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable unit list for the admin Units list page
 */

export function useSearchUnits<TData = Awaited<ReturnType<typeof searchUnits>>, TError = unknown>(
 params?: SearchUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUnits>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchUnitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




